/** Enter/exit fullscreen when the Fullscreen API exists (e.g. not on some mobile browsers). */
export async function toggleElementFullscreen(el) {
    if (typeof document === "undefined")
        return false;
    try {
        if (document.fullscreenElement) {
            await document.exitFullscreen?.();
            return false;
        }
        const requestFs = el.requestFullscreen ??
            el.webkitRequestFullscreen;
        if (typeof requestFs !== "function") {
            return false;
        }
        await requestFs.call(el);
        return true;
    }
    catch {
        return false;
    }
}
//# sourceMappingURL=fullscreen.js.map